import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconArrowRight } from '@redteclab/icons'

import { Button } from 'base-ui'

import { useOpenableControls } from '../../../generic-hooks'
import { ProductPageOdsProvider } from '../../ods/components/productPageODSContext'

import { ProductPageOdsDialogCh } from './ProductPageOdsDialogCh'

export const ProductPageOdsDialogCtaButtonCh: FC = () => {
  const openableControls = useOpenableControls()

  return (
    <ProductPageOdsProvider>
      <Button
        className="mt-4 w-full"
        data-qa-id="form-buybox-large_online-doctor-service"
        endIcon={<IconArrowRight />}
        onClick={openableControls.handleOpen}
        variant="filled"
      >
        <FormattedMessage id="buyBox.link.label.onlineDoctorService.zava" />
      </Button>

      <ProductPageOdsDialogCh
        onClose={openableControls.handleClose}
        open={openableControls.isOpen}
      />
    </ProductPageOdsProvider>
  )
}
